import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PagetoolbarComponent } from '../pagetoolbar/pagetoolbar.component';
import { NewsitemCardComponent } from '../newsitem/newsitem-card/newsitem-card.component';
import { MatchingPeriodService } from '../../services/matchingPeriod.service';
import { ParticipantService } from '../../services/participant.service';
import { NewsitemService } from '../../services/newsitem.service';
import { NewsItem } from '../../interfaces/newsitem';
import { Observable } from 'rxjs';
import { Permission } from '../../interfaces/permission';
import { AuthService } from '../../auth/auth.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  imports: [MatButtonModule, MatCardModule, MatIconModule, MatProgressSpinnerModule, MatTooltipModule, CommonModule, PagetoolbarComponent, NewsitemCardComponent, RouterModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  currentMatchingPeriod?: string;
  currentMatchRun?: number;
  participantCount: number = 0;
  newsitems: NewsItem[] = [];

  showParticipantCount: boolean = false;
  showCurrentMatchingPeriod: boolean = false;
  showLastMatchRun: boolean = false;

  constructor(
    private matchingPeriodService: MatchingPeriodService,
    private participantService: ParticipantService,
    private readonly news: NewsitemService,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.authService.getAllPermissions$().subscribe((permissions) => {
      this.showParticipantCount = permissions.includes(Permission.DASHBOARD_READ);
      this.showCurrentMatchingPeriod = permissions.includes(Permission.DASHBOARD_CYCLE);
      this.showLastMatchRun = permissions.includes(Permission.DASHBOARD_MATCHRUN);

      // Override participant count visibility for HLA_LAB role
      this.authService.getUser().subscribe((user) => {
        if (user.activeRole.name === 'HLA Lab') {
          this.showParticipantCount = false;
        }
      });
      
      console.log('count', this.showParticipantCount);
      if (this.showCurrentMatchingPeriod) {
        this.getCurrentMatchingPeriod();
      }
      if (this.showParticipantCount) {
        this.getParticipantCount();
      }
      this.getAllNewsItems();
    });
  }
  private async getCurrentMatchingPeriod() {
    this.matchingPeriodService.getLatestMatchingPeriod().subscribe((matchingPeriodResult) => {
      console.log('Current matching period:', matchingPeriodResult);
      if (matchingPeriodResult == null) {
        this.currentMatchingPeriod = 'N/A';
        this.currentMatchRun = 0;
      } else {
        this.currentMatchingPeriod = matchingPeriodResult.matchingPeriodName;
        this.currentMatchRun = matchingPeriodResult.matchRuns?.[matchingPeriodResult.matchRuns.length - 1]?.runNumber ?? 0;
      }
    });
  }

  private async getParticipantCount() {
    this.participantService.getParticipantCount().subscribe((countResult) => {
      this.participantCount = countResult;
    });
  }

  getAllNewsItems(): void {
    this.news.getAllNewsItems$().subscribe({
      next: (data) => {
        this.newsitems = data.filter((item) => !item.hide);
        if (this.newsitems.length >= 5) {
          this.newsitems = this.newsitems.slice(0, 4);
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }
}
